import React, { useContext } from 'react';
import styles from './styles.css';
import { FlowContext } from '../../core/flow-engine';
import { MFBeaconButton } from '../../components/Beacon/BeaconComponents';
import PhoneNumber from '../../components/PhoneNumber/PhoneNumber';
import Heading from '../../components/Typography/Heading/Heading';
import { generateGeneralTestID } from '../../generateAutomationTestIDs';
import SelectFundsMethodology from '../../components/SelectFundsMethodology/SelectFundsMethodology';
import SFMethodologyModal from '../../components/SelectFundsMethodology/SFMethodologyModal';
import { modalOpenHandler } from '../../components/Modal/utils';

const InvestmentOptionsScreen = () => {
  const { back, flowProps } = useContext(FlowContext);
  const { title, options: Options } = flowProps;

  return (
    <div>
      <Heading text={title || 'Select Your Funds:'} />
      <Options />
      <SelectFundsMethodology />
      <div className="btn-container">
        <MFBeaconButton
          id="selectFundsMethodologyReviewBtn"
          data-name="selectFundsMethodologyReviewBtn"
          onClick={() => modalOpenHandler('sfMethodologyModal')}
          variant="tertiary"
          label="Review our Criteria"
        />
        <MFBeaconButton
          id="backToTypes"
          data-name={generateGeneralTestID(
            'InvestmentOptionsScreen',
            'BackButton'
          )}
          variant="secondary"
          className="beacon-button-margin-override"
          size="normal"
          onClick={back()}
          label="Back"
        />
      </div>
      <PhoneNumber />
      <style jsx>{styles}</style>
      <SFMethodologyModal />
    </div>
  );
};

export default InvestmentOptionsScreen;
